import React from 'react'
import Lottie from "lottie-react";
import animation from '../../loader.json';
function SetLoader() {
  return (
    <div >
       <Lottie animationData={animation} style={{ height: '100px', width: '100px' }} />
    </div>
  )
}

export default SetLoader
